import Vue from 'vue';
import Vuex from 'vuex';

// Modules
import user from './modules/user';
import news from './modules/news';
import videos from './modules/videos';
import mirror from './modules/mirror';
import admin from './modules/admin';
import snackbar from './modules/snackbar';
import analytics from './modules/analytics';

Vue.use(Vuex);

export default plugins => {
  const store = new Vuex.Store({
    modules: {
      analytics,
      user,
      news,
      videos,
      mirror,
      admin,
      snackbar,
    },
    strict: true,
    plugins,
  });

  if (process.env.NODE_ENV === 'development') {
    store.subscribeAction(action => {
      // eslint-disable-next-line no-console
      console.log(action.type, action.payload);
    });
  }
  return store;
};
